import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DropdownList } from 'react-widgets';
import { SEARCHING_TIME_DELAY } from '../../shared/Constants';

export class AsyncSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selecting: null,
      selected: null,
      selectingRespondent: null,
    };
    this.search = this.search.bind(this);
    this.onChachangenge = this.change.bind(this);
    this.change = this.change.bind(this);
    this.select = this.select.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  search(value) {
    const { dataSearch } = this.props;
    const { selecting } = this.state;
    if (selecting) {
      clearTimeout(selecting);
    }

    const searchTimer = setTimeout(() => {
      dataSearch(value);
    }, SEARCHING_TIME_DELAY);

    this.setState({
      selecting: searchTimer,
    });
  }

  async change(selected) {
    const { onChange } = this.props;
    await this.setState({
      selected,
    });
    onChange(selected);
  }

  async select(res) {
    this.setState({ selectingRespondent: res });
  }

  async toggle(forOpen) {
    await setTimeout(() => {
      const { selectingRespondent } = this.state;
      if (!forOpen) {
        if (!selectingRespondent) {
          this.setState({ selected: null });
        }
      } else {
        this.setState({ selectingRespondent: null });
      }
    });
  }

  render() {
    const {
      data, processing, selectedList, value, ...rest
    } = this.props;
    let { selected } = this.state;
    const fitData = processing ? [] : data;
    const selectedItems = selectedList || [];
    const disabledList = [];
    selectedItems.forEach((item) => {
      disabledList.push(item);
    });
    if (selected) {
      const already = disabledList.find(item => item.id === selected.id);
      if (!already) {
        disabledList.push(selected);
      }
    } else if (value) {
      selected = value;
    }
    return (
      <div>
        <DropdownList
          {...rest}
          readOnly={processing}
          busy={processing}
          data={fitData}
          onSearch={this.search}
          filter={item => item}
          onChange={this.change}
          value={selected}
          onSelect={this.select}
          onToggle={this.toggle}
          disabled={disabledList}
          messages={{
            emptyList: processing ? '...' : null,
          }}
        />
      </div>
    );
  }
}

AsyncSelector.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  processing: PropTypes.bool.isRequired,
  selectedList: PropTypes.arrayOf(PropTypes.any),
  value: PropTypes.string,
  dataSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

AsyncSelector.defaultProps = {
  selectedList: [],
  value: null,
};

export const renderAsyncSelector = (props) => {
  const {
    input,
    meta: { touched, error, warning },
    onSearch,
    ...rest
  } = props;
  return (
    <div>
      <AsyncSelector
        {...input}
        {...rest}
        onChange={input.onChange}
        dataSearch={onSearch}
      />
      {touched
        && ((error && <span style={{ color: '#ce4844' }}>{error}</span>)
          || (warning && <span style={{ color: '#f0ad4e' }}>{warning}</span>))}
    </div>
  );
};

renderAsyncSelector.propTypes = {
  input: PropTypes.objectOf(PropTypes.any).isRequired,
  meta: PropTypes.objectOf(PropTypes.any).isRequired,
  onSearch: PropTypes.func.isRequired,
};
